<template>
    <div>
        <div v-if="team_id" class="team_row">
            <div class="team_name">
                <label>Team Name : </label>
                <div>{{ team_name }}</div>
            </div>
            <button class="btn btn-primary btn-xs" @click="showPicker=true" type="button">Edit</button>
        </div>
        <div v-if="showPicker">
            <b-form-group>
                <b-form-radio-group
                    id="btn-radios-1"
                    v-model="method"
                    :options="availableEntryTypes"
                    buttons
                    button-variant="outline-success"
                    size="sm"
                    :name="`radios-btn-default-${registrationCategoryId}`"
                ></b-form-radio-group>
            </b-form-group>
        </div>
        <div v-if="method==='new'">
            <new-team
                :registration-category-id="primaryCategoryId"
                @created="newTeam"
            ></new-team>
        </div>
        <div v-if="method==='join'">

            <vue-bootstrap-typeahead
                :data="teams"
                v-model="query"
                :size="'sm'"
                :placeholder="'Search for existing team'"
                :serializer="item => item.name"
                @blur="blur"
                ref="team"
                @hit="found"
            ></vue-bootstrap-typeahead>
            <div v-if="showPassword">
                <div v-if=incorrectPassword class="alert alert-danger">
                    Incorrect password. Please try again or contact the team captain for the password
                </div>
                <!--Form Fields-->
                <b-form-group

                    id="example-input-group-71"
                    label="Password"
                    label-for="example-input-17">
                    <b-form-input
                        id="example-input-17"
                        data-vv-as="Team Name"
                        name="password"
                        type="password"
                        :size="'sm'"
                        :required="true"
                        v-model="password"
                        aria-describedby="input-1-live-feedback">
                    </b-form-input>

                </b-form-group>
                <b-button :size="'sm'" variant="success" class="mt-3" block @click="joinTeam">Join Team</b-button>
            </div>
        </div>
        <div
            class="text-danger mt-2 text-left"
            v-if="!validated && showValidationErrors"
        >
            Please select an option, and/or join a team.
        </div>
    </div>
</template>
<script>
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import NewTeam from "./Add.vue";

export default {
    props: {
        fieldMappings: {
            default: () => [],
            required: false,
            type: Array,
        },
        optOutOptions: {
            default: () => [],
            required: false,
            type: Array,
        },
        registrationCategoryId: {
            type: Number,
            required: false,
        },
        registrationCategoryIds: {
            type: Array,
            required: false,
        },
        showValidationErrors: {
            default: false,
            required: false,
            type: Boolean,
        },
        team: {
            type: Object,
            required: false,
        },
        teamIdProp: {
            default: null,
            required: false,
            type: Number,
        },
    },
    components: {
        VueBootstrapTypeahead,
        NewTeam
    },
    data() {
        return {
            id: null,
            incorrectPassword: false,
            method: '',
            password: '',
            query: '',
            showPassword: false,
            showPicker: false,
            team_id: this.teamIdProp,
            team_name: '',
            teams: []
        }
    },
    created() {
        if (!this.team_id) {
            this.showPicker = true;
            this.method = this.availableEntryTypes[0].value;
        } else {
            this.team_id = this.teamIdProp;
            this.team_name = this.team.name
        }

        this.$emit('validation', {fieldName: 'teamPicker', value: this.validated});
    },
    methods: {
        newTeam(team) {
            this.team_name = team.name;
            this.team_id = team.id;
            this.$emit('input', team.id);
            this.showPicker = false;
            this.method = '';
            setTimeout(() => {
                this.$emit('new-team');
            }, 500)
        },
        found(e) {
            if (e.has_password) {
                this.showPassword = true;
                this.team_id = e.id;
                this.team_name = e.name;
                const team = {
                    name: '',
                    id: null
                };
                this.$emit('input', team.id); //This clears the team_id against the participant
            } else {
                this.showPassword = false;
                this.team_id = e.id;
                this.team_name = e.name;
                this.$emit('input', e.id);
            }
        },
        blur(e) {
            this.query = '';
            this.$refs.team.inputValue = '';
            const team = {
                name: '',
                id: null
            };
            this.found(team);
        },

        joinTeam() {
            this.incorrectPassword = false;
            axios.get(`/api/v0/teams/${this.team_id}/${this.password}`)
                .then((res) => {
                    if (res.data.status === "success") {
                        this.team_id = res.data.data.id;
                        this.team_name = res.data.data.name;
                        this.$emit('input', res.data.data.id);
                        this.showPassword = false;
                    } else {
                        this.incorrectPassword = true;
                    }

                })
        },
    },
    computed: {
        availableEntryTypes() {
            let options = [
                {
                    text: 'No, only me',
                    value: 'solo',
                },
                {
                    text: 'Find a team',
                    value: 'join',
                },
                {
                    text: 'Create a team',
                    value: 'new',
                },
            ].filter(option => !this.optOutOptions.includes(option.value));


            return options;
        },
        validated() {
            return this.method === 'solo'
                || Boolean(this.team_id);
        },
        categoryIdsForSearch() {
            // Support both single ID and array of IDs for backward compatibility
            if (this.registrationCategoryIds && this.registrationCategoryIds.length > 0) {
                return this.registrationCategoryIds;
            } else if (this.registrationCategoryId) {
                return [this.registrationCategoryId];
            }
            return [];
        },
        primaryCategoryId() {
            // Used for creating new teams - use first category ID, or null if none
            return this.categoryIdsForSearch.length > 0 ? this.categoryIdsForSearch[0] : null;
        },
    },

    watch: {
        method(method) {
            if (method === 'solo') {
                this.$emit('input', null);
            }
        },
        validated(newVal, oldVal) {
            this.$emit('validation', {fieldName: 'teamPicker', value: newVal});
        },
        query(newQuery) {
            // Build query string with multiple registration_category_id[] parameters
            const categoryParams = this.categoryIdsForSearch
                .map(id => `registration_category_id[]=${id}`)
                .join('&');

            axios.get(`/api/v0/teams?name=${newQuery}&${categoryParams}`)
                .then((res) => {
                    this.teams = res.data.data
                })
        },
    },
}
</script>
<style scoped lang="scss">
.team_row {
    display: flex;
    justify-content: space-between;

    .team_name {
        display: flex;
    }
}

</style>



// WEBPACK FOOTER //
// src/Assets/components/Teams/Form/Picker.vue